export const updateLicenceBind = /* GraphQL */ `
  mutation UpdateLicence(
    $input: UpdateLicenceInput!
    $condition: ModelLicenceConditionInput
  ) {
    updateLicence(input: $input, condition: $condition) {
      id
      userId
      licenceBind {
        items {
          id
          licenceId
          uuid
          device
          auth
          updatedAt
          createdAt
          owner
        }
        nextToken
      }
      uuid
      updatedAt
      owner
    }
  }
`;

// Update: アクティブ
export const updateLicenceActive = /* GraphQL */ `
  mutation UpdateLicence(
    $input: UpdateLicenceInput!
    $condition: ModelLicenceConditionInput
  ) {
    updateLicence(input: $input, condition: $condition) {
      id
      active
      updatedAt
      owner
    }
  }
`;

export const createLicenceMaintenanceHistory = /* GraphQL */ `
  mutation CreateLicenceMaintenanceHistory(
    $input: CreateLicenceMaintenanceHistoryInput!
    $condition: ModelLicenceMaintenanceHistoryConditionInput
  ) {
    createLicenceMaintenanceHistory(input: $input, condition: $condition) {
      id
      licenceId
      userId
      licence {
        id
        userId
        licenceBind {
          nextToken
        }
        type
        period
        subscriptionExpiryDateAt
        maintenancePeriod
        acsVersionId
        acsVersion {
          id
          no
          version
          releaseDate
          active
          updatedAt
          createdAt
        }
        licenceKey
        uuid
        active
        updatedAt
        createdAt
        owner
      }
      user {
        id
        owner
        licenceLimit {
          nextToken
        }
        licence {
          nextToken
        }
        username
        mailaddress
        telephoneNumber
        postalCode
        address
        companyName
        corp
        active
        updatedAt
        createdAt
      }
      owner
      before
      after
      reason
      beforePeriod
      afterPeriod
      beforeSubscriptionExpiryDateAt
      afterSubscriptionExpiryDateAt
      beforeMaintenancePeriod
      afterMaintenancePeriod
      createdAt
      updatedAt
    }
  }
`;